var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.calcPermission(_vm.page, _vm.SpaceAction.CAN_ADD_CHILD))?_c('div',{staticClass:"rounded-button-medium db-50-outline-button",on:{"click":_vm.addNewPage}},[_c('IconPlus'),_vm._v(" New page ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }